import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';  // ✅ this is vercel analytics components

import Navbar from './navi/Navbar';
import Footer from './navi/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProjectsPage from './pages/ProjectsPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import CV from './pages/CV';
import Skills from './pages/Skills';
import WebProjectsPage from './pages/WebProjectsPage';
import BillTrackerPage from './pages/BillTrackerPage';
import ToolsPage from './pages/ToolsPage';
import CiscoSubnetLabPage from './pages/CiscoSubnetLabPage';
import CloudCostEstimatorPage from './pages/CloudCostEstimatorPage';
import GreenOpsEstimatorPage from './pages/GreenOpsEstimatorPage';
import LinuxDevOpsPage from './pages/LinuxDevOpsPage';
import ScrollToTop from './navi/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div style={{display:"flex", flexDirection:"column", minHeight:"100vh"}}>
        <Navbar />
        <div style={{ flex: "1 0 auto" }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/cv" element={<CV />} />
            <Route path='/skills' element={<Skills />} />
            <Route path='/projects/web' element={<WebProjectsPage />} />
            <Route path='/tools' element={<ToolsPage />} />
            <Route path='/tools/cisco-subnet-lab' element={<CiscoSubnetLabPage />} />
            <Route path='/tools/cloud-cost-estimator' element={<CloudCostEstimatorPage />} />
            <Route path='/tools/greenops-carbon-estimator' element={<GreenOpsEstimatorPage />} />
            <Route path='/tools/linux-devops-suite' element={<LinuxDevOpsPage />} />
            <Route path='/bill-tracker' element={<BillTrackerPage />} />
          </Routes>
        </div>
        <Footer />
        <Analytics /> {/* ✅ this is vercel analytics components body part */}
      </div>
    </Router>
  );
}

export default App;


